import { iconList } from "@/lib/get-icon";
import { Component } from "@builder.io/sdk";

export const keyFeaturesConfig: Component = {
  name: "Key Features",
  friendlyName: "Key Features",
  inputs: [
    {
      name: "id",
      type: "string",
      advanced: true,
    },
    {
      name: "className",
      type: "string",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "Care Indeed Powers Your Daily Workflow",
    },
    {
      name: "buttonCta",
      type: "object",
      subFields: [
        {
          name: "label",
          friendlyName: "Button Text",
          type: "string",
        },
        {
          name: "link",
          friendlyName: "Button Link",
          type: "string",
        },
      ],
      defaultValue: {
        label: "Request a Demo",
        link: "#",
      },
    },
    {
      name: "defaultActiveId",
      type: "string",
      defaultValue: "shift-scheduling",
    },
    {
      name: "items",
      type: "list",
      subFields: [
        {
          name: "id",
          type: "string",
        },
        {
          name: "label",
          type: "string",
        },
        {
          name: "value",
          type: "string",
        },
        {
          name: "desktopVideo",
          friendlyName: "Desktop/Tablet Video",
          type: "file",
          allowedFileTypes: ["video/mp4"],
        },
        {
          name: "mobileVideo",
          friendlyName: "Mobile Video",
          type: "file",
          allowedFileTypes: ["video/mp4"],
        },
        {
          name: "leadingIcon",
          type: "text",
          enum: iconList,
        },
        {
          name: "trailingIcon",
          type: "text",
          enum: iconList,
        },
      ],
      defaultValue: [
        {
          id: "shift-scheduling",
          label: "Shift Scheduling",
          value: "shift-scheduling",
          desktopVideo:
            "https://cdn.builder.io/o/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F8f288aeaf6044ba1bb47a7f1d43ee31c%2Fcompressed?apiKey=ad5264505ff74b8ba929a635f7c3c34f&token=8f288aeaf6044ba1bb47a7f1d43ee31c&alt=media&optimized=true",
          mobileVideo:
            "https://cdn.builder.io/o/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F8f288aeaf6044ba1bb47a7f1d43ee31c%2Fcompressed?apiKey=ad5264505ff74b8ba929a635f7c3c34f&token=8f288aeaf6044ba1bb47a7f1d43ee31c&alt=media&optimized=true",
        },
        {
          id: "credentialing",
          label: "Credentialing",
          value: "credentialing",
          desktopVideo:
            "https://cdn.builder.io/o/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F8f288aeaf6044ba1bb47a7f1d43ee31c%2Fcompressed?apiKey=ad5264505ff74b8ba929a635f7c3c34f&token=8f288aeaf6044ba1bb47a7f1d43ee31c&alt=media&optimized=true",
          mobileVideo:
            "https://cdn.builder.io/o/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F8f288aeaf6044ba1bb47a7f1d43ee31c%2Fcompressed?apiKey=ad5264505ff74b8ba929a635f7c3c34f&token=8f288aeaf6044ba1bb47a7f1d43ee31c&alt=media&optimized=true",
        },
        {
          id: "concierge",
          label: "24/7 Concierge",
          value: "concierge",
          desktopVideo:
            "https://cdn.builder.io/o/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F8f288aeaf6044ba1bb47a7f1d43ee31c%2Fcompressed?apiKey=ad5264505ff74b8ba929a635f7c3c34f&token=8f288aeaf6044ba1bb47a7f1d43ee31c&alt=media&optimized=true",
          mobileVideo:
            "https://cdn.builder.io/o/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F8f288aeaf6044ba1bb47a7f1d43ee31c%2Fcompressed?apiKey=ad5264505ff74b8ba929a635f7c3c34f&token=8f288aeaf6044ba1bb47a7f1d43ee31c&alt=media&optimized=true",
        },
      ],
    },
  ],
};
